import type { BillingNote } from '@policyvision/contracts';

import { Client } from '@/common/services/Client';

type BillingNotePayload = Omit<BillingNote, 'createdAt' | 'updatedAt'> & {
  createdAt: string;
  updatedAt: string | null;
};

export async function fetchBillingNotes(
  billingUuid: string,
): Promise<BillingNote[]> {
  const response = await Client.get<BillingNotePayload[]>({
    endpoint: `/billing/${billingUuid}/notes`,
  });
  return response.data.map((note) => ({
    ...note,
    createdAt: new Date(note.createdAt),
    updatedAt: note.updatedAt ? new Date(note.updatedAt) : null,
  }));
}
